// extracted by mini-css-extract-plugin
export default {"main":"Notas_main__tDC1S"};